import { useAtom } from 'jotai';
import {
  accessibilityDataAtom,
  currentAuditEntryAtom,
} from '@/global-store.ts';
import { Trans } from 'react-i18next';
import { Alert, Link as MuiLink } from '@mui/material';
import { reportStorageUrl } from '@http/constants';

export function LastAuditTooOldBanner() {
  const [accessibilityData] = useAtom(accessibilityDataAtom);
  const [currentAuditEntry] = useAtom(currentAuditEntryAtom);

  if (!accessibilityData?.history || !currentAuditEntry?.auditInterval)
    return null;

  const historyKeys = Object.keys(accessibilityData.history);
  const lastAudit = historyKeys[historyKeys?.length - 1];

  if (!lastAudit) return null;

  const lastAuditMs = new Date(lastAudit).getTime();
  const now = new Date().getTime();
  const auditIntervalMs =
    1000 * 60 * 60 * 24 * (currentAuditEntry.auditInterval + 3); // add two day buffer

  if (lastAuditMs + auditIntervalMs > now) return null;

  return (
    <Alert
      severity='error'
      sx={(theme) => ({
        border: '4px solid black',
        color: theme.palette.black.main,
        alignItems: 'center',
        display: 'flex',
        flexWrap: 'nowrap',
        width: '100%',
        my: 3,
        p: 2,
        fontWeight: 700,
      })}
    >
      <Trans
        i18nKey='lastAuditTooOld'
        components={[
          <MuiLink
            key='lastAuditTooOld'
            color='inherit'
            fontWeight={800}
            href={
              reportStorageUrl +
              currentAuditEntry.cdnDirectory +
              '/lastLogs.html'
            }
            rel='noopener noreferrer'
            target='_blank'
            underline='always'
          />,
        ]}
      />
    </Alert>
  );
}
